import { render, staticRenderFns } from "./ionic_tabbar.vue?vue&type=template&id=21cb766b&scoped=true&lang=html"
import script from "./ionic_tabbar.vue?vue&type=script&lang=js"
export * from "./ionic_tabbar.vue?vue&type=script&lang=js"
import style0 from "./ionic_tabbar.vue?vue&type=style&index=0&id=21cb766b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cb766b",
  null
  
)

export default component.exports